import { createStore } from 'vuex'
import { get } from '@/crud'

export default createStore({
  state: {
    user: {
      loggedIn: false,
      data: null
    },
    isLoading: true,
    dersler: [],
    routes: [
      {
        slug: 'miniozet',
        name: 'Mini Özetler'
      },
      {
        slug: 'detay',
        name: 'Detaylı Anlatım'
      },
      {
        slug: 'konutestleri',
        name: 'Konu Testleri'
      },
      {
        slug: 'sinavlar/deneme',
        name: 'Deneme Sınavları'
      },
      {
        slug: 'sifreler',
        name: 'Şifreler'
      },
      {
        slug: 'videohocalar',
        name: 'Videolar'
      }
    ]
  },
  getters: {
    user (state) {
      return state.user
    },
    dersler (state) {
      return state.dersler
    },
    routes (state) {
      return state.routes
    },
    isLoading (state) {
      return state.isLoading
    }
  },
  mutations: {
    SET_LOGGED_IN (state, value) {
      state.user.loggedIn = value
    },
    SET_USER (state, data) {
      state.user.data = data
    },
    SET_LOADING (state, value) {
      state.isLoading = value
    },
    SET_DERSLER (state, value) {
      state.dersler = value
    }
  },
  actions: {

    fetchUser ({ commit }, user) {
      commit('SET_LOADING', false)
      commit('SET_LOGGED_IN', user !== null)
      if (user) {
        commit('SET_USER', {
          displayName: user.displayName,
          email: user.email
        })
      } else {
        commit('SET_USER', null)
      }
    },
    fetchDersler ({ commit }) {
      commit('SET_LOADING', true)
      get({
        child: 'dersler',
        callback: (e) => {
          const data = e.val()
          const arr = []
          Object.keys(data).map((v, k) => {
            arr.push({ firebaseKey: v, ...data[v] })
          })
          commit('SET_DERSLER', arr)
          commit('SET_LOADING', false)
        }
      })
    },
    setLoading ({ commit }, loading) {
      commit('SET_LOADING', loading)
    }
  }
})
